import { useSelector } from "react-redux";
import { useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";

import PlatformValidatorTab from "../../Components/StakingRisk/product/PlatformValidatorTab";
import AssetBlockchainTab from "../../Components/StakingRisk/product/AssetBlockchainTab";
import SimpleParameterTab from "../../Components/StakingRisk/product/SimpleParameterTab";
import { TabsPanel, TabPanel } from "../../Components/StakingRisk/ui/tabs-panel";
import ProductHeader from "../../Components/StakingRisk/product/ProductHeader";
import { DEFAULT_TAB, STAKING_TABS } from "./stakingTabs";

export default function ProductDetail() {

 const navigate = useNavigate();

  const [activeTab, setActiveTab] = useState(DEFAULT_TAB);
  const [activeTabId, setActiveTabId] = useState();
  const [saveStatus, setSaveStatus] = useState(null); // null, 'saving', 'saved', 'error'

  const productName = useSelector((state) => state.StakingRiskReducer.createdStakingRiskName);
  const assessments = useSelector((state)=>{return state.StakingRiskReducer.stakingRiskAssessment});
  const classifications = useSelector((state)=>{return state.StakingRiskReducer.stakingRiskClassifications})

  const handleCreateProduct = useCallback(async () => {
    setSaveStatus("saving");   
  }, [navigate]);
  
  const handleScoreUpdate = useCallback((asset="asset",category, totalScorePercentage, riskScore) => {
    
    },[]);
    
    const renderTabComponent = (tab) => {
  const key = tab.key;
  const id = tab.id;

  switch (key) {
    case STAKING_TABS.ASSET:
      return (
        <AssetBlockchainTab
          assessments={assessments}
          activeTab={id}
          onUpdateScore={(p, r) => handleScoreUpdate(key, p, r)}
          isAsset
        />
      );

    case STAKING_TABS.BLOCKCHAIN:
      return (
        <AssetBlockchainTab
          assessments={assessments}
          activeTab={id}
          onUpdateScore={(p, r) => handleScoreUpdate(key, p, r)}
          isAsset={false}
        />
      );

    case STAKING_TABS.STAKING_PLATFORM:
      return (
        <PlatformValidatorTab
          assessments={assessments}
          activeTab={id}
          onUpdateScore={(p, r) => handleScoreUpdate(key, p, r)}
          isPlatform
        />
      );

    default:
      return (
        <SimpleParameterTab
          assessments={assessments}
          activeTab={id}
          mainParameterName={key}
          mainParameterLabel={`${key} Risk`}
          onUpdateScore={(p, r) => handleScoreUpdate(key, p, r)}
        />
      );
  }
};

return (  
     <div className="p-4 md:p-6 max-w-7xl mx-auto">
      <ProductHeader
        productName={productName}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        setActiveTabId= {setActiveTabId}
        saveStatus={saveStatus}
        onCreateProduct={handleCreateProduct} // This might be better as "Create New" on dashboard        
      />
      <TabsPanel activeTab={activeTab}>
        {classifications?.map(tab => (
          <TabPanel key={tab.key} value={tab.key}>
            {renderTabComponent(tab)}
          </TabPanel>
        ))}
      </TabsPanel>    
    </div>)
    }